<template>
  <el-dialog
    id="department-dialog-component"
    :close-on-click-modal="false"
    :title="departmentDialogTitle"
    :visible.sync="departmentDialog"
    :before-close="closeDepartmentDialog"
    width="800px"
  >
    <div class="department-content">
      <div class="select-container">
        <div class="department-list">
          <AllTreeCheckout
            :refStr="refStr"
            :companyList="departmentList"
            :departmentId="departmentId"
            :selectData="selectData"
            :selectDepartment="selectDepartment"
            @selectTreeNodeList="selectDepartmentHeadTreeNodeList"
          />
        </div>
      </div>
      <div class="border"></div>
      <div class="selected-container">
        <p class="label">已选：</p>
        <div class="selected-content">
          <ul class="selected-list">
            <li
              class="selected-item"
              v-for="(value, index) in selectData"
              :key="index"
            >
              <span class="selected-item-name">
                <img :src="second" class="second">
                {{ value.departmentName }}
              </span>
              <span class="remove" @click="removeSelectData(index)">移除</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDepartmentDialog">取 消</el-button>
      <el-button type="primary" @click="submitDepartmentDialog"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import AllTreeCheckout from "@/components/tree/all-tree-checkout.vue";
import { mapChildThirdDisable, mapChildFourDisable } from "@/common/js/utils.js";
import { getAministerLevel } from "@/common/js/storage.js";
import Staff from "@/models/staff.js";
export default {
  props: {
    refStr: {
      type: String,
      default: "tree",
    },
    departmentDialogTitle: {
      type: String,
      default: "请选择部门",
    },
    /* 角色唯一标识 */
    keyword: {
      type: String,
      default: '',
    },
    /* 模块类型唯一标识 */
    moduleType: {
      type: String,
      default: '',
    },
    departmentDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AllTreeCheckout
  },
  data() {
    return {
      selectDepartment: false,
      second: require('../assets/tree/second.png'),
      searchDepartment: "",
      selectData: [],
      departmentList: [],
      departmentId: 0,
      aministerLevel: '',
      // timerId: null
    };
  },
  created() {
    this.aministerLevel = getAministerLevel()
    this.getDepartmentList()
  },
  mounted () {
    this.$bus.on('initSelectAllDepartmentList', async v => {
      let arr = []
      v.map(i => {
        let obj = {}
        obj.id = i.id
        obj.departmentName = i.name
        arr.push(obj)
      })
      this.$bus.emit('allTreeCheckedLighDate', arr)
      await this.getDepartmentList()
      this.selectData = arr
    })
  },
  // beforeDestroy() {
  //   clearTimeout(this.timerId)
  // },
  methods: {
    /* 获取部门数据 */
    async getDepartmentList() {
      let searchDepartment = ''
      let id = ''
      let keyword = this.moduleType
      let res = await Staff.getChangeDepartmentList(id, searchDepartment, keyword)
        if (res.success) {
          let arr
          if (this.keyword == 'Property' || this.keyword == 'Watchmaker' || this.keyword == 'cashier' || this.keyword == 'FinancialHead' || this.aministerLevel == 3) {
             arr = mapChildThirdDisable(res.result);
          }
          if (this.aministerLevel == 4 && this.keyword != 'Property' && this.keyword != 'Watchmaker' && this.keyword != 'cashier' && this.keyword != 'FinancialHead') {
            arr = mapChildFourDisable(res.result);
          }
          this.$bus.emit('initList', arr)
          this.departmentList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
    },

    /* 移除 */
    removeSelectData(index) {
      this.selectData.splice(index, 1);
      this.$bus.emit('allTreeCheckedDel', this.selectData)
    },

    /* 关闭弹窗 */
    closeDepartmentDialog() {
      this.searchDepartment = "";
      this.selectData = [];
      this.$bus.emit('allTreeCheckedLighDate', [])
      this.$emit("allOPenOrCloseDepartmentDialog", false);
    },

    /* 确定弹窗 */
    submitDepartmentDialog() {
      this.$emit("allSubmitSelectData", this.selectData);
      this.$bus.emit('allTreeCheckedLighDate', [])
    },

    selectDepartmentHeadTreeNodeList(v) {
      // 限制资产管理员只适用于一个三级部门
      // if (this.keyword == 'Property' && v.length>1) {
      //     let arr = []
      //     this.selectData.map(i => {
      //       arr.push(i.id)
      //     })
      //     this.timerId = setTimeout(() => {
      //       this.$bus.emit('allTreeclear', arr)
      //     },100)
      //     return this.$message.error('资产管理员只适用于一个三级部门')
      // }
      this.selectData = v
    }
  },
};
</script>
<style lang='scss'>
#department-dialog-component {
  .el-dialog__body {
    position: relative;
  }
  .department-content {
    margin: 16px 20px;
    border: 1px solid $bg-ShallowLightSnow;
    display: flex;
    justify-content: space-between;
    overflow-y: auto;
    overflow-x: hidden;
    height: 350px;
    .border {
      position: absolute;
      top: 0px;
      left: 50%;
      height: 350px;
      transform: translateX(-50%);
      width: 1px;
      background: $bg-ShallowLightSnow;
    }
    .select-container {
      width: 49%;
      .department-list {
        padding: 12px;
        box-sizing: border-box;
      }
    }
    .selected-container {
      width: 49%;
      padding: 12px;
      box-sizing: border-box;
      .label {
        text-align: left;
        height: 40px;
        line-height: 40px;
        font-size: $fs-medium-s;
      }
      .selected-content {
        padding: 12px;
        box-sizing: border-box;
        .selected-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: $fs-small-l;
          color: $color-grey;
          .second {
            margin-right: 19px;
          }
          .selected-item-name {
            height: 14px;
            line-height: 14px;
          }
          .remove {
            color: #ed6767;
            cursor: pointer;
          }
        }
      }
    }
  }
  .department-dialog-footer {
    display: flex;
    justify-content: center;
    padding-top: 16px;
  }
}
</style>